// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ParticipantWorkVM  {
    _originalTypeClassName = "Loom.BO.ParticipantWorkVM";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ParticipantWorkVM.translate = translateService;
}
this.project_acronym = null;
this.wp_number = null;
this.participant_shortname = null;
this.participant_pic = null;
this.isLeader = false;
this.effort = null;
this.task_number = null;
this.task_title = null;
this.start_month = null;
this.end_month = null;
this.lump_sum_costs = null;
this.ParticipantWorkVMKey = null;
this._key = this.ParticipantWorkVMKey = 0; 
}

static translate: TranslateService;
_key: any;
project_acronym:any;
wp_number:any;
participant_shortname:any;
participant_pic:any;
isLeader:any;
effort:any;
task_number:any;
task_title:any;
start_month:any;
end_month:any;
lump_sum_costs:any;
private _ParticipantWorkVMKey:any;
get ParticipantWorkVMKey(): any {
    return this._ParticipantWorkVMKey;
  }
set ParticipantWorkVMKey(value: any) {
    this._ParticipantWorkVMKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ParticipantWorkVMKey == null || $this.ParticipantWorkVMKey == 0;
            }


}